import script from "./WxPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./WxPopup.vue?vue&type=script&setup=true&lang=js"

import "./WxPopup.vue?vue&type=style&index=0&id=7a4b5d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4b5d30"]])

export default __exports__